import { render, staticRenderFns } from "./DeceasedWill.vue?vue&type=template&id=171f634c"
import script from "./DeceasedWill.vue?vue&type=script&lang=ts"
export * from "./DeceasedWill.vue?vue&type=script&lang=ts"
import style0 from "./DeceasedWill.vue?vue&type=style&index=0&id=171f634c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports